// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#header-1, #footer {
    background: transparent;
}

#modal {
    padding: 2rem;
}

.event.item .header {
    font-size: 20px !important;
    font-weight: 500 !important;
}
/* image filer */
figure {
    position: relative;
}

figure figcaption {
    position: absolute;
    bottom: 0;
    background: #fffb;
    padding: 0.3em;
    font-size: small;
}

#logo {
    padding-left: 1em;
    margin-bottom: 25px;
    height: 52px;
    image-rendering: high-quality;
}
`, "",{"version":3,"sources":["webpack://./assets/src/ipha/style.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;AAC/B;AACA,gBAAgB;AAChB;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,6BAA6B;AACjC","sourcesContent":["#header-1, #footer {\n    background: transparent;\n}\n\n#modal {\n    padding: 2rem;\n}\n\n.event.item .header {\n    font-size: 20px !important;\n    font-weight: 500 !important;\n}\n/* image filer */\nfigure {\n    position: relative;\n}\n\nfigure figcaption {\n    position: absolute;\n    bottom: 0;\n    background: #fffb;\n    padding: 0.3em;\n    font-size: small;\n}\n\n#logo {\n    padding-left: 1em;\n    margin-bottom: 25px;\n    height: 52px;\n    image-rendering: high-quality;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
